// Libraries
import React from 'react';
import { Link, Stack, Typography } from '@mui/material';

// Local
import Feature from './Feature';
import SemanticReadPlatformComparison from './SemanticReadPlatformComparison'
import semanticRead from '../Assets/semantic_read.png';
import idea from '../Assets/idea.svg';
import highlight from '../Assets/highlight.svg';
import laptop from '../Assets/laptop.svg';
// import transferDark from '../Assets/transferDark.png';

const SemanticReadFeature = () => {
  // const theme = useTheme();
  // const isDarkMode = theme.palette.mode === "dark";

  const urlMemsum = "https://doi.org/10.18653/v1/2022.acl-long.450";
  const urlMemsumDQA = "https://doi.org/10.48550/arXiv.2310.06436";

  return (
    <Feature
      title="Read faster, write smarter."
      subtitle="Identify each paper's key points, organize your thoughts directly within Endoc, and export your notes with ease."
      abstractHeader="What makes Endoc unique?"
      abstract={(
        <>
          <SemanticReadPlatformComparison />
          <Stack direction='column' spacing={4} textAlign='left' mb={8}>
            <Typography>
              Get instant highlights of the papers you read. We have trained our AI to extract the sentences of each paper that are most representative of the overall paper, namely the sentences that contain high informational overlap with the paper&apos;s abstract [
              <Link
                href={urlMemsum}
                target="_blank"
                rel="noreferrer"
                sx={{ color: '#265ed5', textDecoration: 'none' }}
              >
                2
              </Link>
              ]. This AI is the best one around and its underlying system won the 2023 DocIU Cup Award [
              <Link
                href={urlMemsumDQA}
                target="_blank"
                rel="noreferrer"
                sx={{ color: '#265ed5', textDecoration: 'none' }}
              >
                3
              </Link>
              ], a competition on document understanding.
            </Typography>
            <Link
              href={urlMemsum}
              target="_blank"
              rel="noreferrer"
              variant='body1'
              sx={{ color: '#265ed5', textDecoration: 'none' }}
            >
              [2] N. Gu, E. Ash, and R.H.R. Hahnloser. MemSum: Extractive Summarization of Long Documents using Multi-step Episodic Markov Decision Processes. ACL 2022.
            </Link>
            <Link
              href={urlMemsumDQA}
              target="_blank"
              rel="noreferrer"
              variant='body1'
              sx={{ color: '#265ed5', textDecoration: 'none' }}
            >
              [3] N. Gu, Y. Gao, and R.H.R. Hahnloser. MemSum-DQA: Adapting An Efficient Long Document Extractive Summarizer for Document Question Answering. DocIU Cup 2023.
            </Link>
          </Stack>
        </>
      )}
      propertyOneImage={idea}
      propertyOneTitle="Automatic summaries"
      propertyOneDescription="Get the highlights of the papers you read"
      propertyTwoImage={highlight}
      propertyTwoTitle="Relevance highlighting"
      propertyTwoDescription="Locate the parts of each paper that relate to your notes"
      propertyThreeImage={laptop}
      propertyThreeTitle="Importing & Exporting"
      propertyThreeDescription="Endoc fits into your existing workflow seamlessly"
      featureImage={semanticRead}
    />
  );
};

export default SemanticReadFeature;